<template>
  <!--  子组件 -->
  <div class="float_button">
    <div
      @click="onBtnClicked"
      ref="floatButton"
      class="float_info"
      :style="{ width: itemWidth + 'px', margin: '5px 10px', height: itemHeight + 'px', left: left + 'px', top: top + 'px' }">
      <slot name="text"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      clientWidth: 0,
      clientHeight: 0,
      timer: null,
      currentTop: 0,
      left: 0,
      top: 0,
      itemWidth: 80, //按钮宽度
      isShort: true,
      itemHeight: 36, // 悬浮按钮高度
      gapWidth: 6, // 距离左右两边距离
      coefficientHeight: 0.6, // 从上到下距离比例
    };
  },
  props: ['width', 'height', 'Cleft'],

  computed: {},
  created() {
    if (this.width) {
      this.itemWidth = this.width;
      this.itemHeight = this.height;
    }
   
    let type = navigator.userAgent;

    console.log('设备', type)

    this.clientWidth = document.documentElement.clientWidth;
    this.clientHeight = document.documentElement.clientHeight;
    if (this.Cleft) {
      this.left = this.Cleft;
      this.top = 0;
    } else {
      this.left = this.clientWidth - this.itemWidth - this.gapWidth - 20;
      this.top = this.clientHeight * this.coefficientHeight;
    }
  },
  watch: {
    left(n, o) {},
  },
  methods: {
    onBtnClicked() {
      this.$emit('change');
    },
    handleScrollStart() {
      console.log('这是啥时候触发呀？ScrollStart');
      this.timer && clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.handleScrollEnd();
      }, 300);
      this.currentTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (this.left > this.clientWidth / 2) {
        this.left = this.clientWidth - this.itemWidth / 2;
      } else {
        this.left = -this.itemWidth / 2;
      }
    },
    handleScrollEnd() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop === this.currentTop) {
        if (this.left > this.clientWidth / 2) {
          this.left = this.clientWidth - this.itemWidth - this.gapWidth;
        } else {
          this.left = this.gapWidth;
        }
        clearTimeout(this.timer);
      }
    },
    bodyScroll(e) {
      e.preventDefault();
    }
  },
  mounted() {
    this.$nextTick(() => {
      const floatButton = this.$refs.floatButton;

      floatButton.addEventListener('touchstart', (e) => {
        floatButton.style.transition = 'none';
        // e.preventDefault(); // 阻止默认事件，防止屏幕滚动
      });

      // 在拖拽的过程中，组件应该跟随手指的移动而移动。
      floatButton.addEventListener('touchmove', (e) => {
        if (e.targetTouches.length === 1) {
          let touch = e.targetTouches[0];
          this.left = touch.clientX - 20;
          this.top = touch.clientY - 25;
          e.preventDefault(); // 阻止默认事件，防止屏幕滚动
        }
      });

      // 拖拽结束以后，重新调整组件的位置并重新设置过度动画。
      floatButton.addEventListener('touchend', () => {
        floatButton.style.transition = 'all 0.3s';
        console.log('拖拽结束后left', this.left);
        if (this.left > document.documentElement.clientWidth / 2) {
          this.left = document.documentElement.clientWidth - this.itemWidth - 20;
        } else {
          this.left = 0;
        }
      });

      window.addEventListener('scroll', this.handleScrollStart);
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScrollStart);
  },
  destroyed() {},
};
</script>

<style lang="less" scoped>
.float_button {
  .float_info {
    box-shadow: #1666ca;
    transition: all 0.3s;
    position: fixed;
    bottom: 436px;
    right: 0;
    margin: 5px 10px;
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center;
    z-index: 99999;
    background: #1666ca;
    background-color: rgba(22, 102, 202, 0.3);
    border-radius: 6px;
    cursor: pointer;
  }
}
</style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
  .float_button {
    display: none;
  }
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
  .float_button {
    display: inline-block;
  }
}
</style>
